export const TYPES = {
  GALLERY_CAROUSEL_NAVIGATE_PREVIOUS: 'GALLERY_CAROUSEL_NAVIGATE_PREVIOUS',
  GALLERY_CAROUSEL_NAVIGATE_NEXT: 'GALLERY_CAROUSEL_NAVIGATE_NEXT',
  GALLERY_CAROUSEL_VIEWPORT_RESIZE: 'GALLERY_CAROUSEL_VIEWPORT_RESIZE',
  GALLERY_CAROUSEL_TOGGLE_CONTROLS: 'GALLERY_CAROUSEL_TOGGLE_CONTROLS',
  GALLERY_CAROUSEL_RESET: 'GALLERY_CAROUSEL_RESET',
};

export const navigatePrevious = () => ({
  type: TYPES.GALLERY_CAROUSEL_NAVIGATE_PREVIOUS,
});

export const navigateNext = () => ({
  type: TYPES.GALLERY_CAROUSEL_NAVIGATE_NEXT,
});

export const viewportResize = viewportDetails => ({
  type: TYPES.GALLERY_CAROUSEL_VIEWPORT_RESIZE,
  viewportDetails,
});

export const toggleControlsAreActive = () => ({
  type: TYPES.GALLERY_CAROUSEL_TOGGLE_CONTROLS,
});

export const reset = () => ({
  type: TYPES.GALLERY_CAROUSEL_RESET,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/galleryActions.js
 **/